import {HashHistory} from 'app/utils/urlState/index';

export const initHashHistory = () => {
    HashHistory.getInstance().init();
};
